var content = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--4-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--4-2!../../../node_modules/sass-loader/dist/cjs.js??ref--4-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EmployeeSheet.vue?vue&type=style&index=0&id=1d2fbbee&lang=scss&scoped=true&");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
